import { createContext, useState } from "react";
import StockroomPOItem from "../../../api/Stockroom/StockroomPOItem";
import { useEffect } from "react";
import ModalSimpleButton from "../../../components/Modal/ModalSimpleButton";
import { Typography } from "@mui/material";

export const StockroomPOItemContext = createContext(null);

export const StockroomPOItemContextProvider = ({ children }) => {
  const [poItems, setPOItems] = useState([]);

  const [hasError, setHasError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (hasError) setIsModalOpen(true);
  }, [hasError]);

  const getAllPOItems = async () => {
    await StockroomPOItem.getAll()
      .then((data) => {
        setPOItems(data);
      })
      .catch((err) => {
        setHasError(err);
        setIsModalOpen(true);
      });
  };

  const getPOItemById = async (itemID, poID) => {
    await StockroomPOItem.getStockroomPOItemById(itemID, poID)
      .then((data) => {
        setPOItems(data);
      })
      .catch((err) => {
        setHasError(err);
        setIsModalOpen(true);
      });
  };

  return (
    <StockroomPOItemContext.Provider
      value={{ poItems, getPOItemById, getAllPOItems }}
    >
      {children}

      <ModalSimpleButton
        title={"Error"}
        buttonText={"Close"}
        buttonAction={() => {
          setIsModalOpen(false);
          setHasError("");
        }}
        setOpen={() => {
          setIsModalOpen(false);
          setHasError("");
        }}
        open={isModalOpen}
      >
        <Typography
          style={{ padding: "0 16px", fontSize: 18, textAlign: "center" }}
        >
          {hasError}
        </Typography>
      </ModalSimpleButton>
    </StockroomPOItemContext.Provider>
  );
};
